import { useState, useEffect } from "react"
import { SearchArticles } from "../api"

const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [showResults, setShowResults] = useState(false)

  const performSearch = async (term) => {
    if (!term.trim()) {
      setSearchResults([])
      return
    }

    setIsSearching(true)

    try {
      const response = await SearchArticles(term)

      if (response && response.results) {
        const formattedResults = response.results.map((result) => ({
          type: "article",
          item: {
            title: result.article.name,
            slug: result.article.slug,
            _id: result.article._id,
          },
          category: result.category
            ? { name: result.category.name, slug: result.category.slug }
            : null,
          displayPath: result.displayPath || [],
          slugPath: result.slugPath || [],
        }))

        setSearchResults(formattedResults)
      } else {
        setSearchResults([])
      }
    } catch (error) {
      console.error("Search error:", error)
      setSearchResults([])
    } finally {
      setIsSearching(false)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm) {
        performSearch(searchTerm)
        setShowResults(true)
      } else {
        setShowResults(false)
        setSearchResults([])
      }
    }, 300)

    return () => clearTimeout(timer)
  }, [searchTerm])

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
    if (!e.target.value.trim()) {
      setSearchResults([])
      setShowResults(false)
    }
  }

  const resetSearch = () => {
    setSearchTerm("")
    setSearchResults([])
    setShowResults(false)
  }

  const closeResults = () => setShowResults(false)

  return {
    searchTerm,
    searchResults,
    isSearching,
    showResults,
    handleSearchChange,
    resetSearch,
    closeResults,
    setShowResults,
    performSearch,
  }
}

export default useSearch
